<c-modal
  [class]="(level | levelClass) + ' ' + modalHeightClass"
  [alignment]="c.alignment || 'center'"
  [backdrop]="c.backdrop"
  [id]="c.id"
  [visible]="visible"
  [size]="c | size"
  scrollable
>
  <c-modal-header>
    <h5 cModalTitle>{{ c.title }}</h5>
    <button (click)="closeMe()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    @if (iamVisible) {
      @switch (c.dialog) {
        @case (modalDialogs.StrategyChooser) {
          <div class="modal-explorer-shell">
            <app-strategy-explorer #targetComponent [isInModal]="true"></app-strategy-explorer>
          </div>
        }
        @case (modalDialogs.MeasureChooser) {
          <div class="modal-explorer-shell">
            <app-measure-explorer #targetComponent [isInModal]="true"></app-measure-explorer>
          </div>
        }
        @case (modalDialogs.KPIChooser) {
          <div class="modal-explorer-shell">
            <app-kpi-explorer #targetComponent [isInModal]="true"></app-kpi-explorer>
          </div>
        }
        @case (modalDialogs.CheckInChooser) {
          <div class="modal-explorer-shell">
            <app-check-in-explorer #targetComponent [isInModal]="true"></app-check-in-explorer>
          </div>
        }
        @case (modalDialogs.RelationshipConfigurator) {
          <app-form-relationship-configuration
            #targetComponent
            [relationshipConfig]="c.model.in.relationshipConfig"
            [isEditing]="c.model.in.isEditing"
            [bizEntityType]="c.model.in.bizEntityType"
            [relationshipId]="c.model.in.relationshipId"
            [bizEntityTypes]="c.model.in.bizEntityTypes"
          >
          </app-form-relationship-configuration>
        }

        @case (modalDialogs.ConfirmationDialogue) {
          <app-confirmation-dialogue
            #targetComponent
            [message]="c.model.in.message"
            [apiMethodCall]="c.model.in.apiMethodCall"
            [bizEntity]="c.model.in.bizEntity"
          ></app-confirmation-dialogue>
        }
        @case (modalDialogs.InputDialogue) {
          <app-input-dialogue
            #targetComponent
            [message]="c.model.in.message"
            [label]="c.model.in.label"
            [placeholder]="c.model.in.placeholder"
            [value]="c.model.in.value"
          ></app-input-dialogue>
        }
        @case (modalDialogs.AddNewField) {
          <app-form-fields
            #targetComponent
            [fieldData]="c.model.in.fieldData"
            [isEditing]="c.model.in.isEditing"
            [existingFields]="c.model.in.existingFields"
          >
          </app-form-fields>
        }
          @case (modalDialogs.BizRules) {
       <app-form-biz-rule [model]="c.model" #targetComponent></app-form-biz-rule>
    }
        @case (modalDialogs.GenericExplorer) {
          <div class="modal-explorer-shell">
            <lib-generic-explorer #targetComponent [exploreBy]="{typeIds: explorerEntityTypeIds}" [entityTypeIds]="explorerEntityTypeIds" [appId]="explorerAppId" [isInModal]="true"></lib-generic-explorer>
          </div>
        }
        @case (modalDialogs.UsersChooser) {
          <div class="modal-explorer-shell">
            <lib-users-explorer #targetComponent [isInModal]="true"></lib-users-explorer>
          </div>
        }
        @case (modalDialogs.MeasureLogForm) {
          <app-form-transaction-log #targetComponent [isInModal]="true"></app-form-transaction-log>
        }
        @case (modalDialogs.PlanItemEdit) {
          <app-plan-item-edit
            #targetComponent
            [date]="c.model.in.date"
            [expected]="c.model.in.expected"
            [unitSymbol]="c.model.in.unitSymbol"
            [minDate]="c.model.in.minDate"
            [maxDate]="c.model.in.maxDate"
            [minExpected]="c.model.in.minExpected"
            [maxExpected]="c.model.in.maxExpected"
            [existingDates]="c.model.in.existingDates"
          ></app-plan-item-edit>
        }
        @case (modalDialogs.GenericConfirmationDialogue) {
          <lib-generic-confirmation-dialogue
            [message]="c.model.in.message"
          ></lib-generic-confirmation-dialogue>
        }
        @case (modalDialogs.CreateAndRelateEntity) {
          <lib-create-and-relate-entity-form
            #targetComponent
            [bizEntityType]="c.model.in.bizEntityType"
          ></lib-create-and-relate-entity-form>
        }
      }

    }
  </c-modal-body>

  <ng-container>
    @if (visible) {
      @if (c | hasFooter) {
        <c-modal-footer id="modalFooter">

          @for (btnConfig of c.footerButtons; track footerButtonsTrackBy($index, btnConfig)) {
           @if(isVisible(btnConfig)){ 
            @if(c.selectedEntityDisplay && btnConfig.getData)
            {
              <div class="selected-entity-display">
                @for(item of c.selectedEntityDisplay; track $index)
                {
                  @if(getData() && !isDisabled(btnConfig)){
                  {{selectedBizEntityText}} {{getData()[item.key]}}
                  }
                }
              </div>
            }
              <div>
                <button
                  (click)="onClick(btnConfig)"
                  cButton
                  [color]="btnConfig.color"
                  [disabled]="isDisabled(btnConfig)"
                >
                  {{ btnConfig.label }}
                </button>
              </div>
            }
        }
        </c-modal-footer>
      }
    }
  </ng-container>
</c-modal>
